import { HeaderButton } from '@/components/HeaderButton';
import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import Plus from '@/images/plusBlack.svg';
import { useOpenCreateAvatarModal } from '@/pages/avatar';
import { useAnalytics } from '@/services/analytics';
import { MixPanelEvent } from '@/utils/types';
import { useTheme } from '@mui/material';
import { useLocation } from 'react-router-dom';

export const CreateAvatar = () => {
    const { pathname } = useLocation();

    const theme = useTheme();
    const mixpanel = useAnalytics();
    const openCreateAvatarModal = useOpenCreateAvatarModal();

    const handleModalOpen = () => {
        mixpanel?.track('avatar-create-modal', {
            event: MixPanelEvent.CLICK,
            from: 'create-avatar-cta',
        });
        openCreateAvatarModal({
            from: pathname,
        });
    };

    return (
        <HeaderButton id="create-avatar-btn" data-testid="create-avatar-button" onClick={handleModalOpen} aria-label="create avatar">
            <MaskedIcon color={theme.colors.black.main} src={Plus} size="24px" />
            Create Avatar
        </HeaderButton>
    );
};
